import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { CopyButton } from '@/components/ui/CopyButton'
import { PageLoader } from '@/components/ui/PageLoader'
import { PageSpinner } from '@/components/ui/PageSpinner'
import { AiAnalysisLoading } from '@/routes/Public/AiAnalysisLoading'
import { Demo, DsSection } from '../primitives'

const PAGE_SPINNER_VARIANTS: { value: string; label?: string }[] = [
  { value: '<PageSpinner label="Loading quotes…" />', label: 'Loading quotes…' },
  { value: '<PageSpinner />' },
]

function PageSpinnerDemo({ value, label }: { value: string; label?: string }) {
  return (
    <div className="flex w-full flex-col items-start gap-2">
      <div className="bg-ink-50 relative h-56 w-full overflow-hidden rounded-xl">
        <PageSpinner contained label={label} />
      </div>
      <div className="text-ink-400 flex items-center gap-1 font-mono text-[10px]">
        <span>{value}</span>
        <CopyButton
          value={value}
          className="text-ink-400 hover:text-ink size-4 bg-transparent hover:bg-transparent"
        />
      </div>
    </div>
  )
}

export function LoadingSection() {
  const [playCount, setPlayCount] = useState(0)
  const [splashCount, setSplashCount] = useState(0)

  return (
    <DsSection
      id="loading"
      title="Loading"
      intro={
        <>
          The <code>&lt;AiAnalysisLoading&gt;</code> component, used on the estimates results page, and the
          full-screen <code>&lt;PageLoader&gt;</code> splash. The splash plays on marketing page loads and,
          with <code>persist</code> and a <code>label</code>, covers the sign-in hop until the next page
          lands.
        </>
      }
    >
      <Demo label="AI analysis sequence" className="flex flex-col items-center gap-6">
        <div className="w-full max-w-2xl">
          <AiAnalysisLoading key={playCount} />
        </div>
        <Button onClick={() => setPlayCount((c) => c + 1)}>Play again</Button>
      </Demo>
      <Demo label="Page loader" className="flex flex-col items-center gap-6">
        {splashCount > 0 && <PageLoader key={splashCount} />}
        <Button onClick={() => setSplashCount((c) => c + 1)}>Play the splash</Button>
      </Demo>
      <Demo label="Page spinner" className="grid gap-6 md:grid-cols-2">
        {PAGE_SPINNER_VARIANTS.map((variant) => (
          <PageSpinnerDemo key={variant.value} {...variant} />
        ))}
      </Demo>
    </DsSection>
  )
}
